import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import PublicLayout from "./components/PublicLayout";
import AdminLayout from "./components/AdminLayout";
import Landing from "./pages/Landing";
import EventsList from "./pages/EventsList";
import EventDetail from "./pages/EventDetail";
import RsvpForm from "./pages/RsvpForm";
import RsvpSuccess from "./pages/RsvpSuccess";
import NewsList from "./pages/NewsList";
import NewsDetail from "./pages/NewsDetail";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Sponsor from "./pages/Sponsor";
import { Privacy, Terms, CaliforniaPrivacy } from "./pages/Legal";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminBroadcasts from "./pages/admin/AdminBroadcasts";
import AdminBroadcastNew from "./pages/admin/AdminBroadcastNew";
import AdminBroadcastDetail from "./pages/admin/AdminBroadcastDetail";
import AdminEvents from "./pages/admin/AdminEvents";
import AdminEventEdit from "./pages/admin/AdminEventEdit";
import AdminRsvps from "./pages/admin/AdminRsvps";
import AdminNews from "./pages/admin/AdminNews";
import AdminNewsEdit from "./pages/admin/AdminNewsEdit";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminAgreements from "./pages/admin/AdminAgreements";
import AdminAgreementView from "./pages/admin/AdminAgreementView";
import SponsorAgreement from "./pages/SponsorAgreement";
import CheckinScreen from "./pages/CheckinScreen";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Landing />} />
              <Route path="/events" element={<EventsList />} />
              <Route path="/events/:slug" element={<EventDetail />} />
              <Route path="/events/:slug/rsvp" element={<RsvpForm />} />
              <Route path="/rsvp/success" element={<RsvpSuccess />} />
              <Route path="/news" element={<NewsList />} />
              <Route path="/news/:slug" element={<NewsDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/sponsor" element={<Sponsor />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/california-privacy" element={<CaliforniaPrivacy />} />
              <Route path="/terms" element={<Terms />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/checkin" element={<CheckinScreen />} />
            <Route path="/sponsor-agreement/:token" element={<SponsorAgreement />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="analytics" element={<AdminAnalytics />} />
              <Route path="events" element={<AdminEvents />} />
              <Route path="events/:id" element={<AdminEventEdit />} />
              <Route path="rsvps" element={<AdminRsvps />} />
              <Route path="broadcasts" element={<AdminBroadcasts />} />
              <Route path="broadcasts/new" element={<AdminBroadcastNew />} />
              <Route path="broadcasts/:id" element={<AdminBroadcastDetail />} />
              <Route path="news" element={<AdminNews />} />
              <Route path="news/:id" element={<AdminNewsEdit />} />
              <Route path="contacts" element={<AdminContacts />} />
              <Route path="agreements" element={<AdminAgreements />} />
              <Route path="agreements/:id" element={<AdminAgreementView />} />
            </Route>
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
